<template>
  <div>
    <div v-if="campaign !== null">
      <div class="alert alert-dismissible fade show" :class="alertType" v-if="displayAlert==true">
        <button type="button" aria-hidden="true" class="close" data-dismiss="alert"
          aria-label="Close" @click="displayAlert = false">
          <i class="nc-icon nc-simple-remove"></i>
        </button>
        <span>{{alertMsg}}</span>
      </div>
      <div class="row">
        <div class="col-md-8">
          <p-button outline type="info" size="sm" round @click="$router.go(-1)">
            <i class="fa fa-chevron-circle-left"></i>
            Back
          </p-button>
        </div>
        <div class="col-md-4">
          <p-button @click="addNewCampaignFile" round outline type="info" size="sm"
            style="float: right;">+ Upload Content</p-button>
          <input style="display: none" type="file" ref="profile" accept="image/*,video/*" @change="onFilePicked">
        </div>
      </div>
      <div class="content">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-header" style="width: 100%">
                <div style="width: 50%">
                  <h5 class="card-title" style="float:left;">
                    {{ campaign.name }}
                  </h5>
                </div>
                <div class="col-md-3 ml-auto" style="text-align:right;"></div>
              </div>
              <div class="card-body">
                <div class="typography-line">
                  <p>
                    <span>Campaign Name</span>
                    {{ campaign.name }}
                  </p>
                </div>
                <div class="typography-line">
                  <p>
                    <span>Description</span>
                    {{ campaign.campaignDescription }}
                  </p>
                </div>
                <div class="typography-line">
                  <p>
                    <span>Start Date</span>
                    {{ startDateString }}
                  </p>
                </div>
                <div class="typography-line">
                  <p>
                    <span>End Date</span>
                    {{ endDateString }}
                  </p>
                </div>
                <div class="typography-line">
                  <p>
                    <span>Landing Page</span>
                    {{ campaign.landingPage }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <!-- Tracking Links -->
            <div class="card">
              <div class="row" style="padding-top: 10px; padding-left: 10px">
                <div class="col" style="padding-top: 15px">
                  <h6 style="font-size: 13px">Tracking Links:</h6>
                </div>
              </div>
              <div v-if="trackingLinkList !== null">
                <div v-if="trackingLinkList.length > 0">
                  <el-table :data="trackingLinkList">
                    <el-table-column label="Name" width="100">
                      <template slot-scope="props">
                        <div style="width: 100%; font-size: 11px">
                          {{ props.row.name }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="Url" width="175">
                      <template slot-scope="props">
                        <div style="width: 100%; font-size: 11px">
                          {{ props.row.shortLink }}
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-else style="padding: 15px">No tracking links.</div>
              </div>
              <div v-else style="padding: 15px">
                Loading...
                <div class="lds-dual-ring"></div>
              </div>
            </div>
            <!-- Campaign Discounts -->
            <div class="card" style="margin-top: 10px">
              <div class="row" style="padding-top: 10px; padding-left: 10px">
                <div class="col" style="padding-top: 15px">
                  <h6 style="font-size: 13px">Discount Codes:</h6>
                </div>
              </div>
              <div v-if="influencerDiscountList !== null">
                <div v-if="influencerDiscountList.length > 0">
                  <el-table :data="influencerDiscountList">
                    <el-table-column label="Code" width="125">
                      <template slot-scope="props">
                        <div style="width: 100%; font-size: 11px">
                          {{ props.row.code }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="Type" width="75">
                      <template slot-scope="props">
                        <div style="width: 100%; font-size: 11px">
                          {{ props.row.type }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="Amount" width="100">
                      <template slot-scope="props">
                        <div style="width: 100%; font-size: 11px">
                          <span v-if="props.row.format == 'fixed_amount'">$</span
                          >{{ Math.abs(props.row.amount)
                          }}<span v-if="props.row.format == 'percentage'">%</span>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-else style="padding: 15px">No discount codes.</div>
              </div>
              <div v-else style="padding: 15px">
                <div class="lds-dual-ring"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p-button @click="$router.push('content-list/' + $route.params.candidateId + '/' + campaign._id)" 
        round outline type="info" size="sm" >
        Submitted Content
      </p-button>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import moment from "moment";
import {
  influencerCampaignReadApi,
  influencerCollaborationDetailApi,
  trackingLinkReadListApi,
  influencerDiscountReadApi
} from "@/config/appSettings";

import store from '@/store/index.js'
export default {
  data: () => ({
    alertMsg: '',
    alertType: '',
    displayAlert: false,
    auth: null,
    loadingOverlay: false,
    campaign: null,
    startDateString: null,
    endDateString: null,
    candidateId: null,
    trackingLinkList: null,
    influencerDiscountList: null
  }),
  name: "InfluencerCollaborationDetail",
  methods: {
    async loadCampaignDetails() {
      try {
        let influencerCampaignResponse = await axios.get(
          `${influencerCollaborationDetailApi}/?usertoken=${
            this.auth
          }&candidate=${this.$route.params.candidateId}`
        );

        console.log("CAMPAIGN DETAILS:", JSON.stringify(influencerCampaignResponse.data));
        
        if (influencerCampaignResponse.data.success === true) {
          this.campaign = influencerCampaignResponse.data.result;
          this.startDateString = moment(this.campaign.startDate).format(
            "MM/DD/YY"
          );
          this.endDateString = this.campaign.endDate;
          if (this.campaign.endDate !== "ongoing") {
            this.endDateString = moment(this.campaign.endDate).format(
              "MM/DD/YY"
            );
          }
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err )
      }
    },
    async loadTrackingLinks() {
      try {
        let loadTrackingLinkUrl = `${trackingLinkReadListApi}/?usertoken=${
          this.auth
        }&influencer=${this.candidateId}`;
        //console.log("TRACKING LINK URL:", loadTrackingLinkUrl);
        let trackingLinkResponse = await axios.get(loadTrackingLinkUrl);

        if (trackingLinkResponse.data.success == true) {
          //console.log("TRACKING LINK RESULTS:", trackingLinkResponse.data);
          this.trackingLinkList = trackingLinkResponse.data.result;
          return;
        }
        //console.log("FAILED TRACKING LINK LIST", trackingLinkResponse);
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadInfluencerDiscounts() {
      try {
        let influencerDiscountResponse = await axios.get(
          `${influencerDiscountReadApi}/${this.candidateId}`
        );
        if (influencerDiscountResponse.data.success == true) {
          if (influencerDiscountResponse.data.result.length > 0) {
            this.influencerDiscountList =
              influencerDiscountResponse.data.result;
            return;
          }
        }
        this.influencerDiscountList = [];
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageContent() {
      this.loadCampaignDetails();
      this.loadTrackingLinks();
      this.loadInfluencerDiscounts();
    },
    addNewCampaignFile() {      
      this.$refs.profile.click()
    },
    onFilePicked(e) {
      const file = e.target.files[0]
      const data = this
      store.dispatch('uploadCampaignFile', {
        file: file, 
        influencer: this.$route.params.candidateId,
        campaign: this.campaign._id
      }).then((response) => {
        if (response) {
          data.alertType = 'alert-success'
          data.alertMsg = 'Campaign file uploaded successfully!'
        } else {
          data.alertType = 'alert-danger'
          data.alertMsg = 'Campaign file not uploaded, try again!'
        }
        data.displayAlert = true
      })
    }
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    if (typeof this.$route.params.candidateId !== "undefined") {
      this.candidateId = this.$route.params.candidateId;
      this.loadPageContent();
    }
  },
};
</script>

<style scoped></style>
